export { default } from './SecondaryTabGroupCDS';
